module.exports = __webpack_public_path__ + "img/113.5582d580.jpg";